import React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';

const Relatorios = asyncComponent(() => import('../relatorios'));
const Ocorrencias = asyncComponent(() =>
  import('../relatorios/02Ocorrencias/0201Ocorrencias')
);
const RelOcorrenciasPdf = asyncComponent(() =>
  import('../relatorios/02Ocorrencias/0202OcorrenciasPdf')
);
const RelProdutividade = asyncComponent(() =>
  import('../relatorios/06Negociador/0601Produtividade')
);
const RelPausas = asyncComponent(() =>
  import('../relatorios/06Negociador/0602Pausas')
);
const RelComissoesNeg = asyncComponent(() =>
  import('../relatorios/06Negociador/0603Comissoes')
);
const RelTitulosCaptadosMensal = asyncComponent(() =>
  import('../relatorios/07ConsultorComercial/0701TitulosCaptadosMensal')
);
const RelTitulosCaptadosFaixa = asyncComponent(() =>
  import('../relatorios/07ConsultorComercial/0702TitulosCaptadosFaixaVencto')
);
const RelCredoresSemBorderos = asyncComponent(() =>
  import('../relatorios/07ConsultorComercial/0703CredoresSemBorderos')
);
const RelComissoesComercial = asyncComponent(() =>
  import('../relatorios/07ConsultorComercial/0704ComissoesComercial')
);
const GeradorDeDocumentos = asyncComponent(() =>
  import('../relatorios/gerador-documentos')
);
const ConsultaGeral = asyncComponent(() =>
  import('../relatorios/01Processos/0101ConsultaGeral')
);
const listaDeProcessos = asyncComponent(() =>
  import('../relatorios/01Processos/0102ListaDeProcessos')
);
const StatusProcxCredor = asyncComponent(() =>
  import('../relatorios/01Processos/0104ProcessosPorCredor')
);
const ProcessosXNegociador = asyncComponent(() =>
  import('../relatorios/01Processos/0105ProcessosPorNegociador')
);
const ProcessosXRegiao = asyncComponent(() =>
  import('../relatorios/01Processos/0106ProcessosPorRegiao')
);

const TitulosCadastrados = asyncComponent(() =>
  import('../relatorios/03Titulos/0301TitulosCadastrados')
);
const listaDeImportacoes = asyncComponent(() =>
  import('../relatorios/03Titulos/0302ListaDeImportacoes')
);
const borderosEntrada = asyncComponent(() =>
  import('../relatorios/03Titulos/0304BorderosEntrada')
);

const listaDeCredores = asyncComponent(() =>
  import('../relatorios/04Credores/0401ListaDeCredores')
);
const RelatorioGerencialCredor = asyncComponent(() =>
  import('../relatorios/04Credores/0402GerencialCredores')
);
const listaDeDevedores = asyncComponent(() =>
  import('../relatorios/05Devedores')
);
const listaRelContasReceber = asyncComponent(() =>
  import('../relatorios/08Financeiro/0801ContasAReceber')
);
const listaRelContasPagar = asyncComponent(() =>
  import('../relatorios/08Financeiro/0802ContasAPagar')
);
const listaRelMovContas = asyncComponent(() =>
  import('../relatorios/08Financeiro/0803MovContas')
);
const listaRemuneracaoPorCredor = asyncComponent(() =>
  import('../relatorios/09Gerencial/0902RemuneracaoCredor')
);
const listaRemuneracaoPorNegociador = asyncComponent(() =>
  import('../relatorios/09Gerencial/0903RemuneracaoNegociador')
);
const RemessaRetornoEntradaConfirmada = asyncComponent(() =>
  import('../relatorios/10RemessaRetorno/1001EntradaConfirmada')
);
const RemessaRetornoLiquidacoes = asyncComponent(() =>
  import('../relatorios/10RemessaRetorno/1002Liquidacoes')
);
const RemessaRetornoDevolucoes = asyncComponent(() =>
  import('../relatorios/10RemessaRetorno/1003Devolucoes')
);
const RemessaRetornoOcorrenciasRel = asyncComponent(() =>
  import('../relatorios/10RemessaRetorno/1004Ocorrencias')
);
const RelatoriosEspecificos = asyncComponent(() =>
  import('../relatorios/Especificos')
);
const TitulosDuplicados = asyncComponent(() =>
  import('../relatorios/03Titulos/0303TitulosDuplicados')
);
const ProcessoSemTitulos = asyncComponent(() =>
  import('../relatorios/01Processos/0107ProcessosSemTitulos')
);
const LogsRelatoriosGerados = asyncComponent(() =>
  import('../relatorios/LogsRelatoriosGerados')
);
const erro404 = asyncComponent(() =>
  import('app/routes/extraPages/routes/404')
);

export default function RelatorioRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/rel/criacao-documentos`}
          component={GeradorDeDocumentos}
          codigo="rel_gerador"
        />

        {/* Ocorrencias - 2.01 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/ocorrencias/listagem`}
          component={Ocorrencias}
          codigo="rel_02"
        />
        {/* Ocorrencias - 2.02 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/ocorrencias/pdf`}
          component={RelOcorrenciasPdf}
          codigo="rel_02"
        />
        {/* Ocorrencias - 2.02
        <PrivateRoute
          path={`${match.url}/rel/acordos-programados/`}
          component={Acordo}
          codigo="rel_02"
        /> */}

        {/* Processos - 1.01 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/processos/consulta-geral`}
          component={ConsultaGeral}
          codigo="rel_01"
        />
        {/* Processos - 1.02 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/processos/listagem`}
          component={listaDeProcessos}
          codigo="rel_01"
        />
        {/* Processos - 1.04 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/processos/status-credor`}
          component={StatusProcxCredor}
          codigo="rel_01"
        />
        {/* Processos - 1.05 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/processos/status-negociador`}
          component={ProcessosXNegociador}
          codigo="rel_01"
        />
        {/* Processos - 1.06 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/processos/por-regiao`}
          component={ProcessosXRegiao}
          codigo="rel_01"
        />
        {/* Processos - 1.07 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/processos/sem-titulos`}
          component={ProcessoSemTitulos}
          codigo="rel_01"
        />

        {/* Titulos - 3.01 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/titulos/cadastrados`}
          component={TitulosCadastrados}
          codigo="rel_03"
        />
        {/* Titulos - 3.02 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/titulos/importacoes`}
          component={listaDeImportacoes}
          codigo="rel_03"
        />
        {/* Titulos - 3.03 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/titulos/duplicados`}
          component={TitulosDuplicados}
          codigo="rel_03"
        />
        {/* Titulos - 3.04 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/titulos/borderos-entrada`}
          component={borderosEntrada}
          codigo="rel_03"
        />

        {/* Credores - 4.01 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/credores/listagem`}
          component={listaDeCredores}
          codigo="rel_04"
        />
        {/* Credores - 4.02 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/credores/gerencial`}
          component={RelatorioGerencialCredor}
          codigo="rel_04"
        />

        {/* Consultor/Comercial - 7.01 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/consultor-comercial/titulos-captados`}
          component={RelTitulosCaptadosMensal}
          codigo="rel_07"
        />
        {/* Consultor/Comercial - 7.03 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/consultor-comercial/faixa-vencimento`}
          component={RelTitulosCaptadosFaixa}
          codigo="rel_07"
        />
        {/* Consultor/Comercial - 7.04 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/consultor-comercial/credores-sem-bordero`}
          component={RelCredoresSemBorderos}
          codigo="rel_07"
        />
        {/* Consultor/Comercial - 7.05 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/consultor-comercial/comissoes`}
          component={RelComissoesComercial}
          codigo="rel_07"
        />

        {/* Financeiro - 8.01 */}
        <PrivateRoute
          path={`${match.url}/rel/contas-a-receber`}
          component={listaRelContasReceber}
          codigo="rel_08"
        />
        <PrivateRoute
          path={`${match.url}/rel/contas-a-pagar`}
          component={listaRelContasPagar}
          codigo="rel_08"
        />
        <PrivateRoute
          path={`${match.url}/rel/mov-contas`}
          component={listaRelMovContas}
          codigo="rel_08"
        />

        {/* Devedores - 5.01 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/devedores/listagem`}
          component={listaDeDevedores}
          codigo="rel_05"
        />

        {/* Negociador - 6.01 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/negociador/produtividade`}
          component={RelProdutividade}
          codigo="rel_06"
        />
        {/* Negociador - 6.02 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/negociador/pausas`}
          component={RelPausas}
          codigo="rel_06"
        />
        {/* Negociador - 6.03 */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/negociador/comissoes`}
          component={RelComissoesNeg}
          codigo="rel_06"
        />

        {/* Gerencial - 9.02 */}
        <PrivateRoute
          path={`${match.url}/rel/lista-remuneracao-credor`}
          component={listaRemuneracaoPorCredor}
          codigo="rel_09"
        />
        {/* Gerencial - 9.03 */}
        <PrivateRoute
          path={`${match.url}/rel/lista-remuneracao-negociador`}
          component={listaRemuneracaoPorNegociador}
          codigo="rel_09"
        />
        {/** Remessa/Retorno */}
        <PrivateRoute
          path={`${match.url}/rel/entrada-confirmada`}
          component={RemessaRetornoEntradaConfirmada}
          codigo="rel_remessa"
        />
        <PrivateRoute
          path={`${match.url}/rel/liquidacoes`}
          component={RemessaRetornoLiquidacoes}
          codigo="rel_remessa"
        />
        <PrivateRoute
          path={`${match.url}/rel/devolucoes`}
          component={RemessaRetornoDevolucoes}
          codigo="rel_remessa"
        />
        {/* exact obrigatorio: senao esta rota captura /rel/ocorrencias/listagem e /rel/ocorrencias/pdf */}
        <PrivateRoute
          exact
          path={`${match.url}/rel/ocorrencias`}
          component={RemessaRetornoOcorrenciasRel}
          codigo="rel_remessa"
        />
        <PrivateRoute
          path={`${match.url}/rel/personalizados`}
          component={RelatoriosEspecificos}
          codigo="rel_personalizados"
        />
        <PrivateRoute
          path={`${match.url}/rel/logs-relatorios-gerados`}
          component={LogsRelatoriosGerados}
          codigo="modulo_relatorios"
        />

        <PrivateRoute
          path={`${match.url}/rel/inicio`}
          component={Relatorios}
          codigo="modulo_relatorios"
        />
        <PrivateRoute
          exact
          path={`${match.url}/rel`}
          component={Relatorios}
          codigo="modulo_relatorios"
        />

        <Route component={erro404} />
      </Switch>
    </>
  );
}
